import React from 'react';
import { Box, IconButton, Modal, styled, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SelectBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.paper,
  boxShadow: 24,
  overflow: 'scroll',
  color: 'black',
  height: '80%',
  borderRadius: '5px',
  padding: 10,
  p: 4,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: '100%',
    padding: 10,
  },
}));
const AmbassadorTerms = ({ handleClose, open }) => {
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <SelectBox>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} />
          <Box>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Typography variant="h5" sx={{ textAlign: 'center' }}>
          SELECT INNOVATIONS BRAND AMBASSADOR PROGRAM TERMS
        </Typography>
        <Typography>
          <b>1. Introduction:</b> These terms outline the agreement between Select Innovations, Inc. ("the Company") and the Brand Ambassador, relating to the Company's Brand Ambassador Program.
        </Typography>
        <Typography>
          <b>2. Brand Ambassador Obligations:</b> Ambassadors are obliged to conduct themselves in a manner that is ethical, professional and in accordance with all applicable laws and regulations.
        </Typography>
        <Typography>
          <b>3. The Brand Ambassador agrees to:</b> Post at least one post or three stories on a social media platform mutually agreed upon by both parties, beginning within one week of acceptance to the Brand Ambassador program.
          Alternatively, they can provide one piece of high-quality video content, approved by the Company, per 6-month period during the term of this Agreement.
        </Typography>
        <Typography>
          <b>4. In exchange for the services provided by the Brand Ambassador, the Company agrees to:</b> Provide the Brand Ambassador with a complimentary Select Membership, currently valued at $450 per year. Offer a preferred rate code
          and link for the Brand Ambassador to share with their friends and followers. Pay the Brand Ambassador a $50 commission for each new approved member they refer to the Company.
        </Typography>
        <Typography>
          <b>5. The Brand Ambassador acknowledges and agrees that:</b> All content created and shared must be in line with the Company's branding and messaging guidelines. The Brand Ambassador may not make any false or misleading statements
          regarding the Company, its products, or its services.
        </Typography>
        <Typography>6. This Agreement will begin on the date its accepted digitally and will continue until terminated by either party.</Typography>
        <Typography>7. Either party may terminate this Agreement at any time, for any reason, by providing 10 days written notice to the other party. Email will constitute appropriate written notice.</Typography>
        <Typography>8. Upon termination, the Brand Ambassador will cease to represent the Company in any capacity.</Typography>
        <Typography>9. This Agreement shall be governed by the laws of the State in which the Company is located.</Typography>
        <Typography>
          <b>10. Changes to Terms:</b> The Company may, at any time, choose to edit, add or delete portions of these terms. Brand Ambassadors will be notified of any changes and it will be their responsibility to review these changes and
          decide whether they wish to continue participating in the program under the updated terms.
        </Typography>
        <Typography>
          <b>11. Acceptance of Terms:</b> By participating in the Company's Brand Ambassador Program, the Brand Ambassador acknowledges that they have read, understood and agreed to be bound by these terms.
        </Typography>
        <Typography>
          <b>12. Confidentiality:</b> During the term of the Ambassador relationship, the Brand Ambassador may receive information regarding the Company, its affiliates, or its business practices that is confidential and not generally known
          by the public (“Confidential Information”). The Brand Ambassador agrees that all Confidential Information remains the sole property of the Company, and the Brand Ambassador has no interest in such information. The Brand Ambassador
          will use Confidential Information only as necessary to fulfill its obligations under this Agreement and will not disclose any Confidential Information to any third party without the prior written consent of the Company. Upon
          termination of this Agreement, the Brand Ambassador will return all Confidential Information to the Company and will not use or disclose any Confidential Information. This clause shall survive the termination of the Ambassador
          relationship.
        </Typography>
        <Typography>
          <b>13. Non-Disparagement:</b> The Brand Ambassador agrees that they will not at any time during the agreement and thereafter make public statements or representations, or cause others to make such statements or representations
          that defame, disparage or in any way criticize the personal and/or business reputation, practices, or conduct of the Company, its employees, directors, or officers. The Brand Ambassador acknowledges and agrees that this
          prohibition extends to public statements or representations made online, including but not limited to social media platforms and forums, blogs, and review sites.
        </Typography>
        <Typography>
          <b>14. Marketing Material Approval and Brand Guidelines Compliance:</b> The Brand Ambassador agrees to only use promotional materials that have been approved in advance by the Company. The Brand Ambassador agrees to submit all
          promotional materials to the Company for approval prior to use. The Brand Ambassador will comply with the Company's brand guidelines, which will be provided to the Brand Ambassador upon acceptance into the Brand Ambassador
          Program. These guidelines may include, but are not limited to, instructions for using the Company's logos, trademarks, images, taglines, and other brand assets. The Company reserves the right to request changes or deny approval of
          materials that do not comply with the brand guidelines or that the Company otherwise deems unsuitable for any reason.
        </Typography>
        <Typography>
          <b>15. Right to Disclose:</b> The Brand Ambassador grants the Company the right to disclose the existence and terms of this Ambassador relationship, including the identity of the Brand Ambassador, in business materials, press
          releases, interviews, promotional materials, and other public communications. The Brand Ambassador also gives consent to the Company to use the Brand Ambassador’s name, likeness, logo, URL, trademarks, trade names, legal names,
          and other identifiers used by the Brand Ambassador, for the purpose of advertising, marketing, announcing, or otherwise publicizing the Brand Ambassador's relationship with the Company.
        </Typography>
        <Typography>
          <b>16. License to Use Content:</b> The Brand Ambassador grants the Company a royalty-free, worldwide, perpetual license to use any written, video, or photo content created by the Brand Ambassador during the term of the Ambassador
          relationship, for any purpose including but not limited to marketing, advertising, and promotional activities, in any media now known or later developed. This license includes the right for the Company to modify, reproduce,
          publicly display, distribute, and create derivative works of the content. This license survives the termination of the Ambassador relationship and this Agreement.
        </Typography>
      </SelectBox>
    </Modal>
  );
};

export default AmbassadorTerms;
